import axios from 'axios'
import Vue from 'vue'
import Vuex from "vuex"
import VueRouter from 'vue-router'
import LightBootstrap from './light-bootstrap-main'
//Store
import store from '@/store'
// Plugins
import App from './App.vue'
// router setup
import routes from './routes/routes'
// vee-validate
import es from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator } from "vee-validate";
import VuePapaParse from 'vue-papa-parse'
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
// configure language
locale.use(lang)
Vue.use(VuePapaParse)

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(VeeValidate)
Validator.localize("es", es);
locale.use(lang)

// ------------------ more setups ---------------------
// le decimos a vuex que requerimos el mudulo subscriber para nuestro store
require('@/store/subscriber')
// definimos una url base para las peticiones axios de forma predeterminada
//axios.defaults.baseURL = 'http://127.0.0.1:8000/api'
axios.defaults.baseURL = 'https://dialnet.aplicacionescorporativas.com/dialnet-backend/api'

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

// llamamos a la accion attempt del store a traves de dispatch para obtener un token en caso de existir en el local storage
store.dispatch('auth/attempt', localStorage.getItem('token')).then( () => {
  new Vue({
    el: '#app',
    store,
    render: h => h(App),
    router
  })
})

